// extracted by mini-css-extract-plugin
module.exports = {"MenuList":"Footer-module--MenuList--2mUN2","TelLink":"Footer-module--TelLink--1zK2n","AttributionContainer":"Footer-module--AttributionContainer--2DbNi"};